import { sound } from "@pixi/sound";
import { GameConsole } from "./console/gameConsole";
import { Game } from "./game";
import { qualityResolution } from "./utils/quality";

export function syncAudioPreferences(): void {
	if (Game.music)
		Game.music.volume = GameConsole.getBuiltInCVar("cv_audio_muted")
			? 0
			: GameConsole.getBuiltInCVar("cv_music_volume");
	if (Game.gameStarted && GameConsole.getBuiltInCVar("cv_match_audio_muted"))
		sound.muteAll();
	else sound.unmuteAll();
}

export function initPresentationSettings(): void {
	const muteButtons = Array.from(
		document.querySelectorAll<HTMLButtonElement>("[data-audio-toggle]"),
	);
	const syncAudio = (): void => {
		syncAudioPreferences();
		for (const button of muteButtons) {
			const lobby = button.dataset.audioToggle !== "match";
			const muted = GameConsole.getBuiltInCVar(
				lobby ? "cv_audio_muted" : "cv_match_audio_muted",
			);
			const label = `${muted ? "Unmute" : "Mute"} ${lobby ? "menu music" : "match audio"}`;
			button.setAttribute("aria-label", label);
			button.title = label;
			button.setAttribute("aria-pressed", String(muted));
			button.querySelector("i")?.classList.toggle("fa-volume-high", !muted);
			button.querySelector("i")?.classList.toggle("fa-volume-xmark", muted);
			const caption = button.querySelector("span");
			if (caption) caption.textContent = label;
		}
	};
	muteButtons.forEach((button) =>
		button.addEventListener("click", () => {
			const setting =
				button.dataset.audioToggle === "match"
					? "cv_match_audio_muted"
					: "cv_audio_muted";
			GameConsole.setBuiltInCVar(setting, !GameConsole.getBuiltInCVar(setting));
			button.blur();
		}),
	);
	GameConsole.variables.addChangeListener("cv_audio_muted", syncAudio);
	GameConsole.variables.addChangeListener("cv_match_audio_muted", syncAudio);
	syncAudio();

	const qualitySelects = Array.from(
		document.querySelectorAll<HTMLSelectElement>("[data-quality-select]"),
	);
	const syncQuality = (): void => {
		const quality = GameConsole.getBuiltInCVar("cv_quality");
		for (const select of qualitySelects) select.value = quality;
		// UI setup also runs before Pixi is ready; its initial resolution uses the same helper.
		if (!Game.pixi.renderer) return;
		const configured = GameConsole.getBuiltInCVar("cv_renderer_res");
		const base =
			configured === "auto" ? window.devicePixelRatio || 1 : Number(configured);
		Game.pixi.renderer.resolution = qualityResolution(base, quality);
		Game.pixi.resize();
	};
	qualitySelects.forEach((select) =>
		select.addEventListener("change", () => {
			const quality = select.value;
			if (quality !== "high" && quality !== "medium" && quality !== "low")
				return;
			GameConsole.setBuiltInCVar("cv_quality", quality);
			select.blur();
		}),
	);
	GameConsole.variables.addChangeListener("cv_quality", syncQuality);
	GameConsole.variables.addChangeListener("cv_renderer_res", syncQuality);
	syncQuality();
}
